import { Machine } from 'xstate';

const memorizeStates = {
    initial: 'loading',
    onEntry: ['memorize/enter'],
    onExit: ['memorize/leave'],
    states: {
        loading: {
            on: {
                COUNTDOWN: 'countdown'
            }
        },
        countdown: {
            on: {
                PLAY: 'playing'
            }
        },
        playing: {
            onEntry: ['memorize/enterPage'],
            onExit: ['memorize/leavePage'],

            on: {
                PREV: {
                    playing: {
                        actions: ['memorize/prev']
                    }
                },
                NEXT: {
                    playing: {
                        actions: ['memorize/next']
                    }
                }
            }
        }
    }
};

const quizItemStates = {
    initial: 'idle',
    states: {
        idle: {
            onEntry: ['quiz/enterTest'],
            onExit: ['quiz/leaveTest'],
            on: {
                SUBMIT_ANSWER: {
                    feedback: { actions: ['quiz/submitTestAnswer'] }
                }
            }
        },
        feedback: {
            on: {
                NEXT_QUIZ_ITEM_TEST: {
                    // only when more tests
                    // idle: { actions: 'installNextQuizItemTest' }
                    idle: { actions: [] }
                }
            }
        }
    }
};

const quizStates = {
    initial: 'loading',
    onEntry: ['quiz/enter'],
    onExit: ['quiz/leave'],
    states: {
        loading: {
            on: {
                COUNTDOWN: 'countdown'
            }
        },
        countdown: {
            on: {
                PLAY: 'playing'
            }
        },
        playing: {
            onEntry: ['quiz/enterItem'],
            onExit: ['quiz/leaveItem'],
            on: {
                NEXT_QUIZ_ITEM: 'playing',
                SKIP_QUIZ_ITEM: {
                    playing: {
                        actions: ['quiz/skipItem']
                    }
                }
            },
            ...quizItemStates
        },
        feedback: {
            //
        },
        stop: {}
    }
};

const sessionStates = {
    initial: 'memorize',
    // initial: 'quiz',
    states: {
        memorize: {
            on: {
                START_QUIZ: 'quiz'
            },
            ...memorizeStates
        },
        quiz: {
            on: {
                LEVEL_FAIL: 'fail',
                LEVEL_SUCCEED: 'success'
            },
            ...quizStates
        },
        fail: {
            onEntry: ['quiz/fail']
        },
        success: {
            onEntry: ['quiz/success']
        }
    }
};

const machine = Machine({
    initial: 'initial',
    strict: true,
    states: {
        initial: {
            on: {
                START: 'session'
            }
        },
        session: {
            on: {
                EXIT_TO_INTRO: 'exit'
            },
            ...sessionStates
        },
        exit: {}
    }
});

export { machine };
